<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <el-card>
                    <el-form :inline="true" label-suffix=":">
                        <el-form-item label='怪兽编号'>
                            <el-input v-model="monsterForm.id" placeholder=''></el-input>
                        </el-form-item>
                        <el-form-item label='怪兽种族'>
                            <el-select v-model="monsterForm.race" clearable>
                                <el-option :key="index"
                                           v-for="(item,index) in monsterRaceOptions"
                                           :label="item.name"
                                           :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="monsterQuery">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>

                <el-table :data="dataHandled" border style="margin-top:20px;width: 100%">
                    <el-table-column prop="id" label='编号'>
                    </el-table-column>
                    <el-table-column label='种族'>
                        <template slot-scope="scope">
                            <template v-for="(raceItem,raceIndex) in scope.row.race.split('_')">
                                <span v-for="i in monsterRaceOptions" v-if="raceItem == i.value">{{i.name + (raceIndex!==scope.row.race.split('_').length-1?'/':'')}}</span>
                            </template>
                        </template>
                    </el-table-column>
                    <el-table-column label='名称'>
                        <template slot-scope="scope">
                            <span>{{$t(scope.row.name)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label='描述'>
                        <template slot-scope="scope">
                            <!--<span></span>-->
                            <el-popover
                                placement="top"
                                title=""
                                width="400"
                                trigger="click"
                                :content="$t(scope.row.description)">
                                <el-button type="text" slot="reference">查看</el-button>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column label='怪兽图标'>
                        <template slot-scope="scope">
                            <el-image class="prop-img" :src="'./static/monster_icon/'+scope.row.id+'.png'" fit="cover"></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="renameCard" label='碎片图标'>
                        <template slot-scope="scope">
                            <el-image class="prop-img"
                                      :src="'./static/item_icon/'+(scope.row.id + 10000)+'.png'"
                                      fit="cover">
                                <div slot="error" class="image-slot">
                                    <span>无</span>
                                </div>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="renameCard" label='觉醒结晶图标'>
                        <template slot-scope="scope">
                            <el-image class="prop-img" :src="'./static/item_icon/'+(parseInt(scope.row.id) + 20000)+'.png'"
                                      fit="cover">
                                <div slot="error" class="image-slot">
                                    <span>无</span>
                                </div>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="renameCard" label='进化光谱图标'>
                        <template slot-scope="scope">
                            <el-image class="prop-img"
                                      :src="'./static/item_icon/'+(scope.row.id + 70000)+'.png'"
                                      fit="cover">
                                <div slot="error" class="image-slot">
                                    <span>无</span>
                                </div>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="renameCard" label='属性详情'>
                        <template slot-scope="scope">
                            <el-button type="text" @click="showMonsterDetail(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                                   layout="total, prev, pager, next, jumper" :total="totalRow">
                    </el-pagination>
                </div>

                <el-dialog :visible.sync="monsterDetailShow" width="40%" lock-scroll center>
                    <div class="monster-detail-img">
                        <div style="font-weight: bold;">{{$t(monsterDetailName)}}</div>
                        <el-image class="prop-img" :src="'./static/monster_icon/'+ monsterDetailId +'.png'"
                                  fit="cover"></el-image>
                    </div>

                    <div v-for="item in evolutions">
                        <el-card v-if="item.id == monsterDetailId">
                                <div slot="header" class="clearfix">
                                    <span style="font-weight: bold;">进化配方</span>
                                </div>

                                <div v-if="item.id == monsterDetailId" class="evolutions-entire">
                                <div v-for="i in item.material.split(',')" class="material-box">
                                    <div v-for="(j,index) in i.split('_')" class="material-content">
                                        <div v-if="index ==0">
                                            <el-image v-if="j>10000" class="prop-img" :src="'./static/item_icon/'+ j +'.png'"
                                                      fit="cover">
                                                <div slot="error" class="image-slot">
                                                    <el-image class="prop-img"
                                                              :src="'./static/item_icon/0.png'"
                                                              fit="cover">
                                                    </el-image>
                                                </div>
                                            </el-image>

                                            <el-image v-if="j>0 && j<10000" class="prop-img" :src="'./static/monster_icon/'+ j +'.png'"
                                                      fit="cover"></el-image>
                                            <div v-for="item0 in arrProp0" v-if="item0.id == j">{{item0.id +'-'+ $t(item0.name)}}</div>
                                            <div v-for="item3 in arrProp3" v-if="item3.id == j">{{item3.id +'-'+ $t(item3.name)}}</div>
                                            <div v-for="item5 in arrConditionProp" v-if="item5.id == j">{{item5.id +'-'+ $t(item5.name)}}</div>
                                            <div v-for="item2 in monsterConfigs" v-if="item2.id == j">{{item2.id +'-'+ $t(item2.name)}}</div>
                                        </div>
                                        <div v-if="index ==1">({{j}})</div>
                                    </div>
                                    <!--<div class="add-text">+</div>-->
                                    <div class="add-text"></div>
                                </div>

                                <div class="oid-box">
                        <span><el-image class="prop-img" :src="'./static/monster_icon/'+item.oid+'.png'"
                                        fit="cover"></el-image></span>
                                    <span v-for="__item in monsterConfigs" v-if="item.oid == __item.id">{{__item.id +'-'+ $t(__item.name)}}</span>
                                </div>

                                <div v-for="m in monsterConfigs" v-if="item.id == m.id && m.race.split('_').length > 1 && m.quality == 4" class="awake-box">
                                    <div class="add-text">+</div>
                                    <div class="awake-content">
                                        <el-image class="prop-img" :src="'./static/item_icon/'+(parseInt(item.id) + 20000)+'.png'"
                                                  fit="cover">
                                            <div slot="error" class="image-slot">
                                                <el-image class="prop-img"
                                                          :src="'./static/item_icon/0.png'"
                                                          fit="cover">
                                                </el-image>
                                            </div>
                                        </el-image>
                                        <span v-for="item6 in arrProp6" v-if="item6.id == item.id">{{item6.id +'-'+ $t(item6.name) + $t('reward_editor.17')}}</span>
                                    </div>
                                </div>
                            </div>
                            </el-card>
                    </div>


                    <el-card>
                        <div slot="header" class="clearfix">
                            <span style="font-weight: bold;">属性</span>
                        </div>
                        <div class="monster-detail-entire" v-for="item in monsterConfigs" :key="item.id" v-if="item.id == monsterDetailId">
                            <div style="width: 50%">
                                <div class="monster-detail-box">
                                    <span>怪兽名</span>
                                    <span class="monster-detail-name">{{$t(item.name)}}</span>
                                </div>

                                <div class="monster-detail-box">
                                    <div>种族</div>
                                    <div>
                                        <template v-for="(raceItem,raceIndex) in item.race.split('_')">
                                            <span v-for="i in monsterRaceOptions" v-if="raceItem == i.value">{{i.name + (raceIndex!==item.race.split('_').length-1?'/':'')}}</span>
                                        </template>
                                    </div>
                                </div>

                                <div class="monster-detail-box">
                                    <span>类型</span>
                                    <span v-if="item.type == 0">肉盾</span>
                                    <span v-if="item.type == 1">辅助</span>
                                    <span v-if="item.type == 2">输出</span>
                                </div>

                                <div class="monster-detail-box">
                                    <span>体力</span>
                                    <span>{{item.con}}</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>攻击力</span>
                                    <span>{{item.atk}}</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>移动速度</span>
                                    <span>{{item.mspd}}</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>霸气</span>
                                    <span>{{item.haki}}</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>每次普通攻击回复能量</span>
                                    <span>{{item.atk_energy_recover}}</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>攻击类型</span>
                                    <span v-if="item.atk_type == 0">近战</span>
                                    <span v-if="item.atk_type == 1">远程</span>
                                </div>
                                <template v-if="item.atk_type == 1">
                                    <div class="monster-detail-box">
                                        <span>射程</span>
                                        <span>{{item.atk_range}}</span>
                                    </div>
                                    <div class="monster-detail-box">
                                        <span>攻击速度</span>
                                        <span>{{item.atk_mspd}}</span>
                                    </div>
                                    <div class="monster-detail-box">
                                        <span>子弹速度</span>
                                        <span>{{item.bullet_speed}}</span>
                                    </div>
                                </template>
                                <div class="monster-detail-box">
                                    <span>体型</span>
                                    <span>{{item.size}}</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>真实伤害</span>
                                    <span>0</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>生物屏障</span>
                                    <span>0</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>普攻血量回复</span>
                                    <span>0</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>自愈血量回复</span>
                                    <span>0</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>血量回复效果</span>
                                    <span>100%</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>能量回复效果</span>
                                    <span>100%</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>增益效果持续时间</span>
                                    <span>100%</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>负面效果持续时间</span>
                                    <span>100%</span>
                                </div>
                            </div>

                            <div class="monster-detail-divider"></div>

                            <div style="width: 50%;height: 100%;">
                                <div class="monster-detail-skill" v-for="skillItem in item.abilities.split(',')">
                                    <div>
                                        <el-image class="prop-img" :src="'./static/monster_ability_icon/'+ skillItem +'.png'"
                                                  fit="cover"></el-image>
                                    </div>

                                    <div v-for="i in skillConfigData" v-if="skillItem == i.id">
                                        <div class="skill-name">{{$t(i.name)}}</div>
                                        <div>{{$t(i.description).replace('{name}',$t(item.name)).replaceAll('{owner}',$t(item.name)).replace('{p1}',i.p1).replace('{p2}',i.p2).replace('{p3}',i.p3).replace('{level_based}',i.level_based.split(',')[0]).replace('{energy}',item.atk_energy_recover)}}(每级提升{{i.level_based.split(',')[1]}})</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-card>

                </el-dialog>
            </section>
        </div>
    </el-card>
</template>

<script>
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import {
        mapState
    } from 'vuex';
    import Utils from '../../lib/utils'
    import commonApi from '../../service/common_api'
    import confApi from '../../service/conf_api'

    export default {
        name: "monster_view",
        data () {
            return {
                monsterForm: {
                    id: '',
                    race: ''
                },

                arrProp0: [],
                arrProp3: [],
                arrProp4: [],
                arrProp6: [],
                arrProp7: [],
                arrProp9: [],
                arrProp10: [],
                arrProp11: [],
                arrProp12: [],
                arrProp13: [],
                arrProp14: [],
                arrProp15: [],
                arrProp16: [],
                arrProp17: [],
                arrProp18: [],
                arrProp19: [],
                arrProp20: [],
                arrProp21: [],
                arrProp22: [],
                arrConditionProp:[],
                monsterConfigs: [],
                propConfig: [],
                emblemEffectConfig: [],
                godConfigs: [],
                wallGainType: [],
                skinGainType: [],
                emblemEntryConfigs: [],
                emblemMainConfigs: [],
                emblemFateConfigs: [],
                // 怪兽种族
                monsterRaceOptions: [
                    {
                        name: '祖龙族',
                        value: 0
                    },
                    {
                        name: '尸鬼族',
                        value: 1
                    },
                    {
                        name: '星灵族',
                        value: 2
                    },
                    {
                        name: '木偶族',
                        value: 3
                    },
                    {
                        name: '远古族',
                        value: 4
                    },
                    {
                        name: '原生族',
                        value: 5
                    }
                ],

                monsterDetailShow: false,
                monsterDetailId: '',
                monsterDetailName: '',
                skillConfigData: [],
                evolutions: []

            }
        },
        mixins: [paginationController, actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        mounted() {
            this.initData();
            this.getReadData();
        },
        methods: {
            initData: function() {
                let self = this;
                let tables = 'monster_config,war_groove_config,skin_config,god_config,emblem_effect_config,prop_config';
                commonApi.getConfs({
                    tables: tables
                }).then(res => {
                    self.monsterConfigs = [];
                    self.propConfig = res.prop_config;
                    self.emblemEffectConfig = res.emblem_effect_config;
                    self.godConfigs = res.god_config;
                    self.wallGainType = res.war_groove_config;
                    self.skinGainType = res.skin_config;

                    res.monster_config.forEach(configItem=>{
                        if (configItem.special === 0){
                            self.monsterConfigs.push(configItem);
                        }
                    })

                    self.totalRow = self.monsterConfigs.length;
                    self.rawData = self.monsterConfigs;
                    self.dataHandled = self.monsterConfigs;


                    let arrProp0 = [];
                    let arrProp3 = [];
                    let arrProp4 = [];
                    let arrConditionProp = [];
                    let arrProp9 = [];
                    let arrProp10 = [];
                    let arrProp11 = [];
                    let arrProp12 = [];
                    let arrProp13 = [];
                    let arrProp14 = [];
                    let arrProp15 = [];
                    let arrProp16 = [];
                    let arrProp18 = [];
                    let arrProp20 = [];
                    let arrProp21 = [];
                    let arrProp22 = [];
                    res.prop_config.forEach(function(item) {
                        let type = item.big_type;
                        if (type == 0) {
                            arrProp0.push(item);
                        } else if (type == 3) {
                            arrProp3.push(item);
                        }  else if (type == 5) {
                            arrConditionProp.push(item);
                        }else if (type == 9) {
                            arrProp9.push(item);
                        }else if(type == 4){
                            arrProp4.push(item);
                        } else if (type == 10) {
                            arrProp10.push(item)
                        } else if (type == 11) {
                            arrProp11.push(item)
                        } else if (type == 12) {
                            arrProp12.push(item)
                        } else if (type == 13) {
                            arrProp13.push(item)
                        } else if (type == 14) {
                            arrProp14.push(item)
                        } else if (type == 15) {
                            arrProp15.push(item)
                        } else if (type == 16) {
                            arrProp16.push(item)
                        } else if (type == 20) {
                            arrProp20.push(item)
                        } else if (type == 21) {
                            arrProp21.push(item)
                        } else if (type == 22) {
                            arrProp22.push(item)
                        }
                    });
                    self.arrProp0 = arrProp0;
                    self.arrProp3 = arrProp3;
                    self.arrProp4 = arrProp4;
                    self.arrProp16 = arrProp16;
                    self.arrProp20 = arrProp20;
                    self.arrProp21 = arrProp21;
                    self.arrProp22 = arrProp22;
                    self.arrConditionProp = arrConditionProp;
                    //元核属性类型: 0-主属性;1-二字词条;2-四字词条;3-宿命
                    let tw = {
                        value: 1,
                        label: this.$t("reward_editor.37"),
                        children: []
                    };
                    let fw = {
                        value: 2,
                        label: this.$t("reward_editor.38"),
                        children: []
                    };
                    let special = {
                        value: 3,
                        label: this.$t("reward_editor.52"),
                        children: [{
                            value: 0,
                            label: this.$t("reward_editor.48"),
                        }]
                    }

                    let twConfigs = [];
                    let fwConfigs = [];
                    res.emblem_effect_config.forEach(function(item) {
                        if (item.type == 0) {
                            self.emblemMainConfigs.push(item);
                        } else if (item.type == 1) {
                            twConfigs.push({
                                value: item.id,
                                label: self.$t(item.name) + '('+self.$t(item.description)+')'
                            });
                        } else if (item.type == 2) {
                            fwConfigs.push({
                                value: item.id,
                                label: self.$t(item.name) + '('+self.$t(item.description)+')'
                            });
                        } else if (item.type == 3) {
                            self.emblemFateConfigs.push(item);
                        }
                    });
                    tw.children = twConfigs;
                    fw.children = fwConfigs;
                    self.emblemEntryConfigs.push(tw);
                    self.emblemEntryConfigs.push(fw);
                    self.emblemEntryConfigs.push(special);
                    self.arrProp9 = arrProp9;
                    self.arrProp10 = arrProp10;
                    self.arrProp11 = arrProp11;
                    self.arrProp12 = arrProp12;
                    self.arrProp13 = arrProp13;
                    self.arrProp14 = arrProp14;
                    self.arrProp15 = arrProp15;

                    let arrProp6 = [];
                    let arrProp19 = [];
                    self.monsterConfigs.forEach(function(item) {
                        let monsterRace = item.race;
                        let monsterQuality = item.quality;
                        let hyperEvolution = item.hyper_evolution;
                        if (monsterQuality === 4 && monsterRace.indexOf("_") > -1) {
                            arrProp6.push(item);
                        }
                        if (hyperEvolution ===1){
                            arrProp19.push(item);
                        }

                    });
                    self.arrProp6 = arrProp6;
                    self.arrProp19 = arrProp19;

                    let arrProp7 = [];
                    res.war_groove_config.forEach(function(item) {
                        let type = item.type;
                        if (type === 3 || type === 4) {
                            arrProp7.push(item);
                        }
                    });
                    self.arrProp7 = arrProp7;
                    //self.glyphFateType = arr2;

                    self.evolutions = [];
                    for (var i in self.monsterConfigs) {
                        var arr = self.monsterConfigs[i].evolutions.split("@");
                        for (var j in arr) {
                            self.evolutions.push({
                                id: arr[j].split("#")[0],
                                material: arr[j].split("#")[1],
                                oid: self.monsterConfigs[i].id
                            })
                        }
                    }
                })
            },
            // 怪兽技能信息
            getReadData() {
                confApi.getReadData({
                    token: this.token,
                    tableName: 'skill_config'
                }).then(res => {
                    this.skillConfigData = res;
                })
            },

            // 怪兽详细信息
            showMonsterDetail(data) {
                this.monsterDetailShow = true;
                this.monsterDetailId = data.id;
                this.monsterDetailName = data.name;
            },

            monsterQuery() {
                let self = this;
                let race = self.monsterForm.race;
                let id = self.monsterForm.id;
                let monsterConfigs = [];
                self.monsterConfigs.forEach(item => {
                    if (race !== '' && id !== '') {
                        if (id == item.id) {
                            let raceArr = item.race.split('_');
                            raceArr.forEach(raceItem => {
                                if (race == raceItem) {
                                    monsterConfigs.push(item);
                                }
                            })
                        }
                    } else if (race !== '' && id == '') {
                        let raceArr = item.race.split('_');
                        raceArr.forEach(raceItem => {
                            if (race == raceItem) {
                                monsterConfigs.push(item);
                            }
                        })
                    } else if (race == '' && id !== '') {
                        if (id == item.id) {
                            monsterConfigs.push(item);
                        }
                    } else {
                        monsterConfigs = self.monsterConfigs;
                    }
                })

                self.totalRow = monsterConfigs.length;
                self.rawData = monsterConfigs;
                self.dataHandled = monsterConfigs;
            }
        }
    }
</script>

<style scoped>

</style>

<style lang="less">
    .prop-img {
        width: 50px;
        height: 50px;
    }

    .evolutions-entire {
        display: flex;
        align-items: center;
        /*margin-bottom: 20px;*/
    }

    .material-box {
        display: flex;
        align-items: center;
    }

    .material-content {
        display: flex;
        flex-direction: column;
        text-align: center;
        align-self: flex-end;
    }

    .add-text {
        margin: 0 10px;
    }

    .oid-box {
        display: flex;
        flex-direction: column;
        text-align: center;
    }

    .awake-box {
        display: flex;
        align-items: center;
    }

    .awake-content {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .monster-detail-box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        border-bottom: 1px #999999 solid;
    }

    .monster-detail-divider {
        display: inline-block;
        width: 1px;
        margin: 0 8px;
        height: auto;
        background-color: #dcdfe6;
    }

    .monster-detail-entire {
        display: flex;
        justify-content: space-between;
    }

    .monster-detail-img {
        text-align: center;
        margin-bottom: 20px;
    }

    .monster-detail-skill {
        display: flex;
        align-items: center;
        margin-bottom: 26px;
    }

    .monster-detail-name {
        font-weight: bold;
    }

    .skill-name {
        margin-bottom: 10px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/views/plot_tools/monster_view.vue